import SmartExchangeClaimsManager from '@/manager/2.6/SmartExchangeClaimsManager';
import ISmartExchangeClaims from '@/models/se/ISmartExchangeClaims';

export default {
    /**
     * Fetches smart exchange claims within the store. Currently delegates to the SmartExchangeClaimsManager.
     * The dependency order between managers and stores is currently backward on this.
     * Store helpers are placeholders for backward dependency order situations and will go away
     * when we correct it, refactoring the business logic out of the store.
     * @param request
     * @returns
     */
    async getClaims(): Promise<ISmartExchangeClaims> {
        const claims = await SmartExchangeClaimsManager.getClaims();
        return claims;
    }
};
